/**
 * @generated SignedSource<<9e3e77d0746bc3ecf32bfba5a2190d4f>>
 * @relayHash 780e3a7a813607a465be8ff312159bf4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7485cd388657b74bc2f7a70e71e07478a2ac3a09c61eec3532a2c774ed69caa8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type useOnAttemptToUpgradeQuery$variables = {
  entitlementId: string;
};
export type useOnAttemptToUpgradeQuery$data = {
  readonly confluence_tenantContext: {
    readonly editions: {
      readonly confluence: ConfluenceEdition;
    };
  } | null | undefined;
  readonly growthUnifiedProfile_getEntitlementProfile: {
    readonly lastKnownTrial: {
      readonly trialEndTimeStamp: number | null | undefined;
      readonly trialType: GrowthUnifiedProfileTrialType | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useOnAttemptToUpgradeQuery = {
  response: useOnAttemptToUpgradeQuery$data;
  variables: useOnAttemptToUpgradeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entitlementId"
  }
],
v1 = [
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "Editions",
        "kind": "LinkedField",
        "name": "editions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "confluence"
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "entitlementId",
        "variableName": "entitlementId"
      }
    ],
    "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
    "kind": "LinkedField",
    "name": "growthUnifiedProfile_getEntitlementProfile",
    "plural": false,
    "selections": [
      {
        "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
        "kind": "LinkedField",
        "name": "lastKnownTrial",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "trialEndTimeStamp"
          },
          {
            "kind": "ScalarField",
            "name": "trialType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useOnAttemptToUpgradeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useOnAttemptToUpgradeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "7485cd388657b74bc2f7a70e71e07478a2ac3a09c61eec3532a2c774ed69caa8",
    "metadata": {},
    "name": "useOnAttemptToUpgradeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "820db4ce96418a3fddbba24a6e3e5636";

export default node;
